import React from 'react'
import { Form, Cascader } from 'antd'
import { getOptionsCascader } from '../util/FormHelper'

const { SHOW_CHILD } = Cascader;


const FormIteamLists = ({ lists }) => {
    return (
        <Form.Item
            name="lists"
            label="Listas"
            rules={[{ required: true, message: 'Por favor ingresa las listas' }]}
        >
            <Cascader
                style={{ width: '100%', height: '100px' }}
                options={getOptionsCascader(lists)}
                multiple
                showCheckedStrategy={SHOW_CHILD}
            />
        </Form.Item>
    )
}

export default FormIteamLists